import { render, staticRenderFns } from "./ReminderAlert.vue?vue&type=template&id=6ccd5fd8"
import script from "./ReminderAlert.vue?vue&type=script&lang=js"
export * from "./ReminderAlert.vue?vue&type=script&lang=js"
import style0 from "./ReminderAlert.vue?vue&type=style&index=0&id=6ccd5fd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports